import Vue from 'vue';
import siteList from './site-list.vue';

export default () => {
  new Vue({
    el: '#site-list',
    components: {
      'site-list': siteList,
    },
    template: '<site-list />',
  });
};
